export default defineNuxtRouteMiddleware(async () => {
  await useUser().load()
})
